var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoFavorites = function SvgNoFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 122"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2015",
    d: "M18.912 120.934v1h2v-1zm2-114.785a1 1 0 1 0-2 0zm0 114.785V6.149h-2v114.785zM99.948 120.934v1h2v-1zm2-114.785a1 1 0 0 0-2 0zm0 114.785V6.149h-2v114.785z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE0800",
    stroke: "#BE0800",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M61.292 86.089c26.208 0 37.357-10.525 39.656-15.787V29.257c-3.364 7.367-16.006 15.837-39.656 15.837-25.173 0-41.38-9.522-41.38-15.837v41.045c2.874 5.262 15.173 15.787 41.38 15.787Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M54.416 53.017c-2.036-.148-3.84.67-5.147 1.971-2.578 2.564-3.373 7.196-.177 10.396l.028.028 10.336 9.375a.82.82 0 0 0 1.103 0l10.336-9.375.03-.028c3.177-3.183 2.378-7.815-.191-10.382-1.304-1.302-3.105-2.124-5.139-1.98-1.828.13-3.746 1.033-5.588 2.888 0 0-2.058-2.636-5.59-2.893",
    clipRule: "evenodd"
  })));
};
export default SvgNoFavorites;